import {
	Box,
	Drawer,
	DrawerBody,
	DrawerCloseButton,
	DrawerContent,
	DrawerOverlay,
	Flex,
	Icon,
	useDisclosure
} from '@chakra-ui/react';
import { useRef } from 'react';
import { IoMenuOutline } from 'react-icons/io5';
import SidebarContent from './components/Content';
import { AppRoute } from '../../routes';

interface SidebarResponsiveProps {
	routes: AppRoute[];
}

export function SidebarResponsive(props: SidebarResponsiveProps) {
	const { routes } = props;
	const { isOpen, onOpen, onClose } = useDisclosure();
	const btnRef = useRef<HTMLDivElement>(null);

	return (
		<Flex display={{ base: 'flex', xl: 'none' }} alignItems='center'>
			<Flex ref={btnRef} w='max-content' h='max-content' onClick={onOpen} cursor='pointer'>
				<Icon as={IoMenuOutline} color='secondaryGray.600' my='auto' w='20px' h='20px' me='10px' />
			</Flex>
			<Drawer isOpen={isOpen} onClose={onClose} placement='left' finalFocusRef={btnRef}>
				<DrawerOverlay />
				<DrawerContent w='260px' maxW='260px' bg='navy.900'>
					<DrawerCloseButton color='white' zIndex='3' onClick={onClose} _focus={{ boxShadow: 'none' }} />
					<DrawerBody maxW='260px' px='0px' pb='0'>
						<Box>
							<SidebarContent routes={routes} />
						</Box>
					</DrawerBody>
				</DrawerContent>
			</Drawer>
		</Flex>
	);
}

export default SidebarResponsive;
